import { searchJellyfin } from "@/backend/jellyfin/api";
import { SimpleCache } from "@/utils/cache";
import { MediaItem } from "@/utils/mediaTypes";

import { MWQuery } from "./types/mw";

// Cache key is "{serverUrl}:{searchQuery}" so different servers don't share results
const cache = new SimpleCache<string, MediaItem[]>();
cache.setCompare((a, b) => a === b);
cache.initialize();

export async function searchForMedia(
  query: MWQuery,
  serverUrl: string,
  token: string,
  userId: string,
): Promise<MediaItem[]> {
  const cacheKey = `${serverUrl}:${query.searchQuery.trim()}`;
  if (cache.has(cacheKey)) return cache.get(cacheKey) as MediaItem[];

  const results = await searchJellyfin(
    serverUrl,
    token,
    userId,
    query.searchQuery,
  );

  // cache results for 1 hour
  cache.set(cacheKey, results, 3600);
  return results;
}
